import { GuestGuard } from 'components/auth/guest-guard';

// eslint-disable-next-line react/display-name
export const withGuestGuard = (Component) => (props) =>
    (
        <GuestGuard>
            <Component {...props} />
        </GuestGuard>
    );
